module.exports = __webpack_public_path__ + "img/6y.00232929.png";